// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VYShf","largestCol":"styles_largestCol__1G2_2","smallestCol":"styles_smallestCol__3MPAy"};